import { render, staticRenderFns } from "./GenerateExtinguisherModal.vue?vue&type=template&id=0c71640e&scoped=true"
import script from "./GenerateExtinguisherModal.vue?vue&type=script&lang=js"
export * from "./GenerateExtinguisherModal.vue?vue&type=script&lang=js"
import style0 from "./GenerateExtinguisherModal.vue?vue&type=style&index=0&id=0c71640e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c71640e",
  null
  
)

export default component.exports